export default {
    title_list: 'Подписки пользователей',
    title_page: 'Подписка пользователя',
    title_create_page: 'Создать подписку пользователя',
    title_edit_page: 'Изменить подписку пользователя',

    labels: {
        payments_table: 'Платежи',
        card: 'Карта',
        cost: 'Сумма',
        braintree_id: 'Braintree ID',
        created_at: 'Дата',
    },

    filter: {
        labels: {
            user_id: 'Пользователь',
            plan_id: 'Тарифный план',
            braintree_id: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'Пользователь',
            plan_id: 'Тарифный план',
            braintree_id: 'Braintree ID',
            price: 'Стоимость',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'Пользователь',
        plan_id: 'Тарифный план',
        braintree_id: 'Braintree ID',
        price: 'Стоимость',
        paid: 'Оплата',
        start_at: 'Дата начала',
        ends_at: 'Дата окончания',
        active: 'Активна',
        gift: 'Подарок',
        card_mask: 'Карта',
        card_type: 'Тип карты',
    },
}
